"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _ErrorBoundary = _interopRequireDefault(require("../ErrorBoundary"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * An instance of ErrorBoundary that traps errors emitted when rendering the
 * footer. When an error is emitted during render, it is captured, and an HTML
 * comment is added to the page, indicating that the component could not render.
 */
class ComponentBoundary extends _ErrorBoundary.default {
  constructor(props) {
    super(props);
  }
  render() {
    if (this.state.hasError) {
      return /*#__PURE__*/_react.default.createElement("section", {
        "aria-label": "footer navigation",
        className: "mm-footer",
        dangerouslySetInnerHTML: {
          __html: `<!-- ${this.props.name} could not render -->`
        }
      });
    }
    return /*#__PURE__*/_react.default.createElement("section", {
      "aria-label": "footer navigation",
      className: "mm-footer"
    }, this.props.children);
  }
}
var _default = exports.default = ComponentBoundary;